import { createFileRoute } from "@tanstack/react-router";
import { PortalReportsV2Page } from "@/components/v2/pages/portal-reports-v2-page";

export const Route = createFileRoute("/portal/reports/")({
  component: PortalReportsV2Page,
});
